import React from "react"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import { Dialog, FlatButton, TextField } from "material-ui"
import { ISchedulePatternTemplate, ISchedulePatternTemplateItemWithQty } from "../../../../models"
import * as utils from "../../../../helpers/utils"
interface IProps {
  editPatternTemplateWithQty: ISchedulePatternTemplateItemWithQty
  handleClose(): void
  handleUpdatePatternTemplateQty(patternTemplate: ISchedulePatternTemplate, quantity: number): void
}
interface IState {
  quantity: number
  errorQuantity: string
}

export default class EditPatternTemplateQtyDialog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      quantity: props.editPatternTemplateWithQty.quantity,
      errorQuantity: "",
    }
    autobind(this)
  }

  handleSave() {
    if (!this.checkValidate()) return
    this.props.handleUpdatePatternTemplateQty(this.props.editPatternTemplateWithQty.patternTemplate, this.state.quantity)
  }

  checkValidate() {
    let isValidate = true

    if (this.state.quantity <= 0) {
      this.setState({ errorQuantity: strings.formatString(strings.This_field_must_be_greater_than_x, 0) as string })
      isValidate = false
    }
    else if (this.state.quantity > 200) {
      this.setState({ errorQuantity: strings.formatString(strings.This_field_must_be_less_than_or_equal_to_x, 200) as string })
      isValidate = false
    }
    else {
      this.setState({ errorQuantity: "" })
    }
    return isValidate
  }

  render() {
    return (
      <Dialog
        open={true}
        title={strings.Edit_Shift_Quantity}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        contentStyle={{ width: 300, maxWidth: "none" }}
        actions={[
          <FlatButton
            data-intercom-target={"PaternTemplate-Btn-CloseEditPatternTemplateQtyDialog"}
            label={strings.CANCEL}
            secondary={true}
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"PaternTemplate-Btn-UpdateQty"}
            label={strings.Update}
            primary={true}
            onClick={this.handleSave}
          />
        ]}
      >
        <hr />
        <div style={{ paddingRight: 20, paddingLeft: 20, position: "relative" }}>
          <TextField
            data-intercom-target={"PaternTemplate-Btn-Entry-Qty"}
            floatingLabelText={strings.Qty}
            type="number"
            value={this.state.quantity}
            onChange={(e, value) => utils.validateInteger(value) && this.setState({ quantity: value }, () => this.checkValidate())}
            style={{ width: 50 }}
          />
          <span style={{ position: "absolute", left: 20, top: 65, color: "rgb(244, 67, 54)", fontSize: 12 }}>
            {this.state.errorQuantity}
          </span>
        </div>
      </Dialog>
    )
  }
}